
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-invoice",
      function () {
        return require("private-next-pages/download-invoice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download-invoice"])
      });
    }
  